module.exports = __webpack_public_path__ + "static/media/emot3_on.e3c87465.svg";